import React, { Fragment } from 'react'

const NullMssg = (mssg) => {
  const styles = {
    text: {
      textAlign: 'center',
      paddingTop: '60px',
      fontSize: '22px',
      color: 'white',
      mixBlendMode: 'difference',
    },
  }

  return (
    <div style={styles.text} colSpan='100%'>
      <div>{mssg.mssg}</div>
    </div>
  )
}
export default NullMssg
